
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Check, Calendar, Gift } from "lucide-react";
import { ReferralReward } from "@/hooks/useReferrals";

interface RewardCardProps {
  reward: ReferralReward;
  isClaimingReward: boolean;
  onClaimReward: (rewardId: string) => void;
}

const RewardCard = ({ reward, isClaimingReward, onClaimReward }: RewardCardProps) => {
  return (
    <div className="p-4 bg-green-50 border border-green-100 rounded-lg flex justify-between items-center">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center">
          <Gift className="h-5 w-5 text-green-600" />
        </div>
        <div>
          <div className="font-medium text-green-800 flex items-center">
            <Calendar className="h-4 w-4 mr-1 text-green-600" />
            Free Month of Premium
          </div>
          <div className="text-sm text-green-700 mt-1">
            {reward.rewardValue}
          </div>
          <div className="text-xs text-green-600 mt-1">
            Reached {reward.milestoneCount} referrals
          </div>
        </div>
      </div>
      {reward.claimed ? (
        <Badge 
          variant="outline"
          className="bg-gray-100 text-gray-800 hover:bg-gray-100"
        >
          <Check className="h-3 w-3 mr-1" />
          Claimed
        </Badge>
      ) : (
        <Button
          size="sm" 
          variant="default"
          className="bg-green-500 hover:bg-green-600 text-white"
          onClick={() => onClaimReward(reward.id)}
          disabled={isClaimingReward}
        >
          {isClaimingReward ? "Processing..." : "Claim Reward"}
        </Button>
      )}
    </div>
  );
};

export default RewardCard;
